<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1231_29575)">
      <path d="M7.25829 9.75801L9.41663 11.9163C9.74163 12.2413 10.2666 12.2413 10.5916 11.9163L12.75 9.75801C13.275 9.23301 12.9 8.33301 12.1583 8.33301H7.84163C7.09996 8.33301 6.73329 9.23301 7.25829 9.75801Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_1231_29575">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
